<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Voucher</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper ml-2">
                        <b-form-input class="mr-2"
                            v-model="input.filterName" name="filterTable"
                            type="search"
                            id="filterInput"
                            placeholder="Nama"
                            @keyup.enter="onFilter" 
                            ></b-form-input>
                            <b-form-select class="ml-2 mr-2" v-model="input.filterType" id="filterInput" name="levelRole" :options="optionType" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Tipe Voucher</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select class="ml-2 mr-2" v-model="input.filterIsActive" id="filterInput" name="levelRole" :options="optionStatus" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="voucherAddBtn" @click="inputVoucher">Input Voucher</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="voucher"
                :fields="fields" 
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data Voucher.
                </template>
                <template v-slot:cell(price)="row">
                            <div class="text-right no-wrap">{{ $helper.addThousandSeparator(row.item.price) }}</div>
                </template>
                <template v-slot:cell(type)="row">
                    {{ getVoucherType(row.item.type) }}
                </template>
                <template v-slot:cell(isActive)="row">
                    <div class="d-flex flex-wrap" style="gap: 6px;">
                        <b-badge style="width: 79px; padding: 5px;" :variant="activeBadge(row.item.isActive).variant">
                            {{ activeBadge(row.item.isActive).text }}
                        </b-badge>
                        <b-badge style="width: 79px; padding: 5px;" :variant="publicBadge(row.item.isPublic).variant">
                            {{ publicBadge(row.item.isPublic).text }}
                        </b-badge>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                <div class="no-wrap d-flex align-items-center">
                    <!-- Detail -->
                    <b-button
                    size="sm"
                    class="mr-2 table-button edit"
                    v-b-tooltip.hover
                    title="Detail"
                    name="voucherViewBtn"
                    @click="getVoucherDetail(row.item.id)"
                    >
                    <i class="fa fa-info"></i>
                    </b-button>

                    <!-- Edit -->
                    <b-link :to="`${$route.path}/${row.item.id}`">
                    <b-button
                        size="sm"
                        class="mr-2 table-button edit"
                        v-b-tooltip.hover
                        title="Edit"
                        name="voucherEditBtn"
                    >
                        <i class="fa fa-pencil-square-o"></i>
                    </b-button>
                    </b-link>

                    <!-- Go to Voucher Code (kecuali type 2) -->
                    <b-link
                        :to="{
                            path: `/master/voucher/code/${row.item.id}`,
                            query: { data: JSON.stringify(row.item) }
                        }"
                        :class="{ 'hidden-slot': row.item.type === 2 }"
                        >
                        <b-button
                            size="sm"
                            class="mr-2 table-button info"
                            v-b-tooltip.hover
                            title="Lihat Kode Voucher"
                            :disabled="row.item.type === 2"
                        >
                            <i class="fa fa-ticket"></i>
                        </b-button>
                    </b-link>

                    <!-- Toggle Active -->
                    <b-button
                        size="sm"
                        :variant="row.item.isActive ? 'danger' : 'success'"
                        v-b-tooltip.hover
                        :title="row.item.isActive ? 'Nonaktifkan' : 'Aktifkan'"
                        class="mr-2"
                        @click="confirmToggle(row.item)"
                        style="width: 102px;"
                    >
                    {{ row.item.isActive ? 'Nonaktifkan' : 'Aktifkan' }}
                    </b-button>

                    <b-button
                        size="sm"
                        :variant="row.item.isPublic ? 'secondary' : 'primary'"
                        v-b-tooltip.hover
                        :title="row.item.isPublic ? 'Tarik Publikasi' : 'Publikasikan'"
                        @click="onPublic(row.item)"
                        style="width: 102px;"
                    >
                    {{ row.item.isPublic ? 'Tarik Publikasi' : 'Publikasikan' }}
                    </b-button>

                </div>
                </template>

            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>

        <b-modal id="modal-detail-voucher" title="Detail Voucher" no-close-on-backdrop v-model="showModal">
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">INFORMASI VOUCHER</h6>
                
                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nama Voucher</b-col>
                <b-col v-if="voucherDetail.name">{{ voucherDetail.name }}</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Harga Voucher(poin)</b-col>
                <b-col v-if="voucherDetail.price">{{ voucherDetail.price}}</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Deskripsi</b-col>
                <b-col 
                style="max-width: 100%; white-space: pre-wrap; word-break: break-word;"
                v-if="voucherDetail.description">{{ voucherDetail.description }}</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Kebijakan</b-col>
                <b-col 
                style="max-width: 100%; white-space: pre-wrap; word-break: break-word;"
                v-if="voucherDetail.policy">{{ voucherDetail.policy }}</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Masa Berlaku</b-col>
                <b-col v-if="voucherDetail.expiryDate">{{ voucherDetail.expiryDate }} hari</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Tipe Voucher</b-col>
                <b-col>{{ getVoucherType(voucherDetail.type) }}</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Diskon Voucher</b-col>
                <b-col v-if="voucherDetail.discount">{{ voucherDetail.discount }}%</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Maksimum Voucher</b-col>
                <b-col v-if="voucherDetail.maximum">Rp {{ $helper.addThousandSeparator(voucherDetail.maximum)}}</b-col>
                <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Status</b-col>
                <b-col>
                    <div class="d-flex flex-wrap" style="gap: 6px;">
                        <b-badge style="width: 79px; padding: 5px;" :variant="activeBadge(voucherDetail.isActive).variant">
                            {{ activeBadge(voucherDetail.isActive).text }}
                        </b-badge>
                        <b-badge style="width: 79px; padding: 5px;" :variant="publicBadge(voucherDetail.isPublic).variant">
                            {{ publicBadge(voucherDetail.isPublic).text }}
                        </b-badge>
                    </div>
                </b-col>
                </b-row>
            </div>

            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">FOTO VOUCHER</h6>
                <b-row class="mb-2">
                <b-col cols="12">
                    <b-img 
                    :src="`${$baseFilePath}${voucherDetail.photo}`" 
                    fluid 
                    class="border rounded w-100" 
                    alt="Foto Voucher"
                    />
                </b-col>
                </b-row>
            </div>

            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" @click="cancel()">
                Tutup
                </b-button>
            </template>
            </b-modal>
            <b-modal
            id="confirm-toggle-modal"
            v-model="showConfirmModal"
            :title="modalTitle"
            @ok="proceedToggle"
            >
            <div>
            {{ modalMessage }}
            </div>
            </b-modal>

        <ModalConfirm id="modal-confirm-public" title="Konfirmasi Publikasikan Voucher" :isSubmitting="isLoadingSubmitPublic" @submit="handlePublic">
            Apakah anda yakin ingin publikasikan voucher "{{ selectedVoucher ? selectedVoucher.name : '' }}"?
        </ModalConfirm>
        <ModalConfirm id="modal-confirm-pull-public" title="Konfirmasi Tarik Publikasi Voucher" :isSubmitting="isLoadingSubmitPublic" @submit="handlePublic">
            Apakah anda yakin ingin tarik publikasi voucher "{{ selectedVoucher ? selectedVoucher.name : '' }}"?
        </ModalConfirm>

    </div>
</template>

<script>
export default {
    name: 'gadai-voucher',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterType: null,
                filterName: null,
                filterIsActive: null,
                sortBy: "id",
                sortDesc: "desc"
            },
            fields: [
                { key: "name", label: "Nama Voucher"},
                { key: "type", label: "Tipe"},
                { key: "price", label: "Harga"},
                { key: "isActive", label: "Status"},
                { key: "action", label: "Aksi"},
            ],
            voucher: [{
                cabang: []
            }],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            optionType :[
                { id: 1, name: 'Diskon PGI'},
                { id: 2, name: 'Undian PGI'},
                { id: 3, name: 'External'},
            ],
            optionStatus: [
                { id: true, name: 'Aktif'},
                { id: false, name: 'Tidak Aktif'},
            ],
            filter: null,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            showModal: false,
            voucherDetail: {},
            showConfirmModal: false,
            selectedVoucher: null,
            modalTitle: '',
            modalMessage: '',
            isLoadingSubmitPublic: false,
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            
            let getVoucher = this.$axios.get("voucher/"+this.query).then(response => {
                this.voucher = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getVoucher]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Ambil Data Voucher -----------------

        getVoucher(){
            this.toggleBusy()
            this.voucher = []
            
            if (this.input.filterType != null) this.query = this.query + "&filterType=" + this.input.filterType
            if (this.input.filterName != null) this.query = this.query + "&filterName=" + this.input.filterName
            if (this.input.filterIsActive != null) this.query = this.query + "&filterIsActive=" + this.input.filterIsActive
            // if (this.input.sortBy != null) {
            //     if (this.input.sortBy == "fullname") this.query = this.query + "&sortBy=fullName"
            //     else this.query = this.query + "&sortBy=" + this.input.sortBy
            // }
            // if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("voucher/"+this.query).then(response => {
                this.voucher = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getVoucher()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getVoucher()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterType = null
            this.input.filterName = null
            this.input.filterIsActive = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getVoucher()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getVoucher()
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
    
        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputVoucher(){
            this.$router.push({path: `${this.$route.path}/input`});
        },
        getVoucherDetail(id) {
        this.showModal = true;
        this.voucherDetail = {}; // reset data
        this.$axios.get(`voucher/${id}`)
        .then(res => {
            this.voucherDetail = res.data;
        })
        .catch(err => {
            console.error(err);
            this.$bvToast.toast('Gagal mengambil data detail.', {
                title: 'Error',
                variant: 'danger',
                solid: true
            });
        });
        },
        getVoucherType(typeId) {
        const type = this.optionType.find(item => item.id === typeId);
        
        return type ? type.name : '-';
    },
    async toggleVoucherStatus(id) {
        try {
        await this.$axios.get(`voucher/switch/${id}`);
        this.$bvToast.toast('Status voucher berhasil diubah', {
            title: 'Sukses',
            variant: 'success',
            solid: true
        });
        this.onReset()
        } catch (error) {
        this.$bvToast.toast('Gagal mengubah status voucher', {
            title: 'Error',
            variant: 'danger',
            solid: true
        });
        console.error(error);
        }
    },
    confirmToggle(voucher) {
      this.selectedVoucher = voucher;
      this.modalMessage = `Apakah Anda yakin ingin ${
        voucher.isActive ? 'menonaktifkan' : 'mengaktifkan'
      } voucher "${voucher.name}"?`;
       this.modalTitle = `Konfirmasi ${voucher.isActive ? 'Nonaktifkan' : 'Aktifkan'} Voucher`;
      this.showConfirmModal = true;
    },
        proceedToggle() {
            if (this.selectedVoucher) {
                this.toggleVoucherStatus(this.selectedVoucher.id);
            }
        },
        publicBadge(isPublic) {
            return {
                text: isPublic ? 'Publik' : 'Tidak Publik',
                variant: isPublic ? 'primary' : 'secondary'
            }
        },
        activeBadge(isActive) {
            return {
                text: isActive ? 'Aktif' : 'Tidak Aktif',
                variant: isActive ? 'success' : 'danger'
            }
        },
        onPublic(row) {
            this.selectedVoucher = row
            if (row.isPublic) {
                this.$bvModal.show('modal-confirm-pull-public')
            } else {
                this.$bvModal.show('modal-confirm-public')
            }
        },
        handlePublic() {
            this.isLoadingSubmitPublic = true;
            const idVoucher = this.selectedVoucher.id;
            const isPublic = this.selectedVoucher.isPublic;
            const url = `voucher/update-public/${idVoucher}?isPublic=${isPublic ? 0 : 1}`;

            this.$axios.put(url).then(response => {
                this.$helper.toastSucc(this, response.data.name)
                this.getVoucher()
                if (isPublic) {
                    this.$bvModal.hide('modal-confirm-pull-public')
                } else {
                    this.$bvModal.hide('modal-confirm-public')
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isLoadingSubmitPublic = false;
            })
        }
    },

    
    created(){
        this.init()
    }
}
</script>

<style scoped>
.hidden-slot {
    visibility: hidden;
    pointer-events: none;
    cursor: default;
}
</style>